export default "__VITE_ASSET__BOoSzc5m__"